import i18next from "i18next";
import { useEffect } from "react";
import { Button, Stack } from "react-bootstrap";
import { PopoverWrap } from "../TooltipLink";
const LanguageSelector = () => {
    const handleLanguageChange = (option) => {
        i18next.changeLanguage(option);
        window.location.reload();
    };
    useEffect(() => {
        if (
            !localStorage.getItem("i18nextLng") ||
            localStorage.getItem("i18nextLng")?.length > 2
        ) {
            i18next.changeLanguage("en");
        }
    }, []);
    return (
        <PopoverWrap
            title={i18next.t("utils.onepatient:select_language")}
            placement="left"
        >
            <Stack direction="horizontal" gap={0}>
                <Button
                    variant={
                        localStorage.getItem("i18nextLng") === "fr"
                            ? "outline-light text-light-green fw-bold"
                            : "outline-primary text-white"
                    }
                    className="border border-0"
                    disabled={localStorage.getItem("i18nextLng") === "fr"}
                    onClick={() => handleLanguageChange("fr")}
                >
                    Français
                </Button>
                <Button
                    variant={
                        localStorage.getItem("i18nextLng") === "en"
                            ? "outline-light text-light-green fw-bold"
                            : "outline-primary text-white"
                    }
                    className="border border-0"
                    disabled={localStorage.getItem("i18nextLng") === "en"}
                    onClick={() => handleLanguageChange("en")}
                >
                    English
                </Button>
            </Stack>
        </PopoverWrap>
    );
};

export default LanguageSelector;
